<template>
    <div class="inner">
        <div class="left">
            <div class="top">
                <icon-title title="会员申请量环比增速" iconName="huiyuanshenqingliang"></icon-title>
                <div class="chart" id="chart1">

                </div>
            </div>
            <div class="bottom">
                <icon-title title="各类会员的年龄分布" iconName="geleihuiyuan"></icon-title>
                <div class="chart" id="chart2">

                </div>
            </div>
        </div>
        <div class="center">
            <div class="top map">
                <icon-title title="会员地域分布" iconName="huiyuandiyu" class="lg"></icon-title>
                <div class="chart" id="map">

                </div>
            </div>
            <div class="bottom table">
                <section class="module_list">
                    <div class="estimate_header">
                        <ul>
                            <li>学会名称</li>
                            <li>本年度会员申请数量</li>
                        </ul>
                    </div>
                    <div class="estimate_body" ref="estimateList">
                        <div>
                            <dl v-for="(item,index) in assessData" :key="index">
                                <dd>{{ item.name }}</dd>
                                <dd>{{ item.value }}</dd>
                            </dl>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="各类会员的学历分布" iconName="huiyichuangban"></icon-title>
                <div class="chart" id="chart4">

                </div>
            </div>
            <div class="bottom">
                <icon-title title="各类会员的性别分布" iconName="lingyuhuiyi"></icon-title>
                <div class="chart" id="chart5">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';

    import {
        getApplicationVolume,
        getApplicationCount,
        memberRegion,
        memberAge,
        memberEdu,
        memberSex
    } from '@/assets/scripts/api/xhqj'

    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = ['#4256d4', '#05c0fb', '#30cf70', '#ef9412', '#fb058f'];
    const mapColor = ['#8592FF', '#6978FF', '#4E60F9', '#384DDF', '#293FCA', '#1831B2'];
    const areaColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        }
    ];

    const GRID = {
        left: '0',
        top: '8%',
        bottom: '9%',
        right: '3%',
        containLabel: true
    };

    export default {
        name: 'HuiYuanQingKuang',
        components: {
            IconTitle
        },
        data() {
            return {
                chinaData: [],
                assessData: [],
                splitArrOpts: {
                    show: true,
                    areaStyle: {
                        color: ['#12173c', 'transparent']
                    }
                }
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                // 会员申请量环比增速
                getApplicationVolume().then(({data}) => {
                    this.initchart1(data);
                })

                // 会员地域分布
                memberRegion().then(({data}) => {
                    this.initchart3(data);
                })

                // 各类会员的学历分布
                memberEdu().then(({data}) => {
                    this.initchart4(data);
                })

                // 各类会员的年龄分布
                memberAge().then(({data}) => {
                    this.initchart2(data);
                })


                // 各类会员性别分布
                memberSex().then(({data}) => {
                    this.initchart5(data);
                })


                // 本年度会员申请排行
                getApplicationCount().then(({data}) => {
                    this.assessData = data.list;

                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.estimateList);
                    });

                })


            },
            initchart1(data) {
                const chart1 = echarts.init(document.getElementById('chart1'));
                const option = this.getLineOption(data);

                chart1.setOption(option, true);
                chart1.resize();
                this.$winResize(chart1.resize);
            },
            initchart2(data) {
                const chart2 = echarts.init(document.getElementById('chart2'));
                const option = this.getBarOption(data);

                chart2.setOption(option, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            initchart4(data) {
                const chart4 = echarts.init(document.getElementById('chart4'));
                const option = this.getBarOption(data);

                chart4.setOption(option, true);
                chart4.resize();
                this.$winResize(chart4.resize);
            },
            initchart5(data) {
                const chart5 = echarts.init(document.getElementById('chart5'));
                const option = this.getBarOption(data);

                chart5.setOption(option, true);
                chart5.resize();
                this.$winResize(chart5.resize);
            },
            // 中国地图初始化
            initchart3(data) {
                const map = echarts.init(document.getElementById('map'));
                const option = this.getMapOption(data);

                map.setOption(option);
                map.resize();
                this.$winResize(map.resize);
            },

            getLineOption(data){
                let option,
                    seriesData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                color: areaColor[index].line,
                                lineStyle: {
                                    color: areaColor[index].line,
                                }
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: areaColor[index].area
                                }, {
                                    offset: 1,
                                    color: areaColor[index].area
                                }])
                            }
                        },
                        data: item
                    });

                });

                option = {
                    grid: GRID,
                    tooltip: {
                        trigger: 'axis',
                        formatter: (e) => {
                            let list = [],
                                listItem,
                                labelName = e[0].axisValueLabel;

                            list.push(`<span>${labelName}</span>`);

                            e.forEach((item, i) => {
                                let unit = i >= 1 ? '%' : '';

                                list.push(`<i style="display:inline-block;width:10px;height:10px;background:${barColor[i]};border-radius:50%;}"></i>
                                        <span>${item.seriesName}</span>&nbsp&nbsp:${item.value}${unit}`);
                            });

                            listItem = list.join('<br>');
                            return `<div class="showBox">${listItem}</div>`;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            margin: 17,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        data: data.column
                    },
                    yAxis: {
                        type: 'value',
                        scale: false,
                        nameTextStyle: {
                            color: '#8CC1FF'
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            formatter: '{value}',
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            show: false,
                        },
                    },
                    series: seriesData
                };

                return option;

            },
            getMapOption(data) {
                let option = {};
                let valData = [];
                let mapData = data.map((item) => {
                    valData.push(item.list['会员数'])
                    return {
                        value: item.list['会员数'],
                        percent: item.list['占比'],
                        name: item.name
                    };
                });

                option = {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter: function (params) {
                            var str = '<span>' + params.name + ':' + params.value + '</span></br><span>占比:' + params.data.percent + '%</span>';
                            return str;
                        },
                        backgroundColor: 'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'china',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#090D28',
                                borderWidth: 1,
                                areaColor: '#8592FF',
                                shadowColor: 'rgba(133,146,255,.3)',
                                shadowBlur: 50
                            },
                            emphasis: {
                                areaColor: '#4E60F9'
                            }
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, valData),
                        show: false,
                        calculable: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [{
                        type: 'map',
                        geoIndex: 0,
                        data: mapData
                    }]
                };

                return option;
            },
            getBarOption(data) {
                let option,
                    seriesData = [],
                    lengendData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        type: 'bar',
                        stack: '总量',
                        barWidth: 20,
                        barGap: '10%',
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[index]
                            }
                        },
                        data: item
                    });

                    lengendData.push({
                        name: data.title[index],
                        icon: 'rect',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })
                });

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 20,
                        bottom: '0',
                        data: lengendData
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (e) => {
                            let list = [],
                                listItem,
                                labelName = e[0].axisValueLabel;

                            list.push(`<span>${labelName}</span>`);

                            e.forEach((item, i) => {
                                list.push(`<i style="display:inline-block;width:10px;height:10px;background:${barColor[i]};border-radius:50%;}"></i>
                                        <span>${item.seriesName}</span>&nbsp&nbsp:${item.value}%`);
                            });

                            listItem = list.join('<br>');
                            return `<div class="showBox">${listItem}</div>`;
                        }
                    },
                    grid: GRID,
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            margin: 17,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: data.column
                    },
                    yAxis: {
                        nameTextStyle: {
                            color: '#8CC1FF'
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: lineColor,
                                type: 'dotted'
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            },
                            formatter: '{value} %'
                        }
                    },
                    series: seriesData
                };
                return option;
            },
            getPart3Option(data) {
                let seriesData = [],
                    option = {};

                data.list.forEach((item, index) => {
                    let obj = {};

                    obj.value = parseFloat(item);
                    obj.name = data.column[index];

                    if (index == 0) {
                        obj.selected = true;
                    }
                    seriesData.push(obj);
                });

                option = {
                    color: ['#fec02f', '#40e4ff', '#1f6eff', '#e47509'],
                    series: [{
                        name: '',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '50%'],
                        label: {
                            show: false
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: seriesData
                    }]
                };

                return option;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 2% 2.08% 0;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .left {
            float: left;
            width: 26.8%;
            height: 100%;

            .top {
                height: 47.86%;
            }

            .bottom {
                height: 52.14%;
            }

        }

        .right {
            @extend .left;
            float: right;
        }

        .center {
            float: left;
            width: 43%;
            height: 100%;
            margin: 0 1.6%;

            .top {
                height: 65%;
            }

            .bottom {
                height: 31%;
            }
        }

        .map {
            position: relative;
            background: url('~@/assets/images/mapbg.png') no-repeat 5px 42px / auto 18.8%;

            &:after {
                display: inline-block;
                content: '';
                width: 83.77%;
                height: 9.875%;
                background: url('~@/assets/images/mapline.png') no-repeat center center / 100% 100%;
                @include position(absolute, auto, auto, 5.49%, 50%);
                transform: translateX(-50%);
            }
        }
    }

    .module_list {
        position: relative;
        width: 78.38%;
        margin: 0 auto;
        height: 100%;

        .field_map {
            height: 100%;
        }

        .estimate_header {
            background: rgba(27, 39, 109, 0.5);
            border: 1px solid $borderColor;

            ul {
                @include clearfix;
                width: 100%;

                li {
                    float: left;
                    width: 62.9%;
                    height: 44px;
                    line-height: 44px;
                    font-size: 14px;
                    color: #E7F0FC;
                    text-align: center;
                    border-right: 1px solid $borderDrakColor;

                    &:last-child {
                        width: 37.1%;
                        border-right: transparent;
                    }
                }
            }
        }

        .estimate_body {
            height: calc(100% - 44px);
            border: 1px solid $borderColor;
            border-top: transparent;
            overflow-y: hidden;

            &::-webkit-scrollbar {
                width: 16px;
                background-color: #1f6eff;
            }

            &::-webkit-scrollbar-track {
                border: 1px solid #1f6eff;
                background-color: #0e214d;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: #1f6eff;
            }

            dl {
                @include clearfix;

                &:nth-child(2n) {
                    background: rgba(20, 29, 81, 0.3);
                }

                dd {
                    float: left;
                    width: 62.9%;
                    height: 44px;
                    line-height: 44px;
                    font-size: 14px;
                    color: #B5C8FF;
                    text-align: center;
                    border: {
                        right: 1px solid $borderDrakColor;
                        bottom: 1px solid $borderDrakColor;
                    }
                    padding-left: 30px;
                    text-align: left;

                    &:last-child {
                        width: 37.1%;
                        border: {
                            right: transparent;
                            bottom: transparent;
                        }
                        text-align: center;
                        padding-left: 0px;

                    }
                }
            }
        }
    }

</style>